import redFlagPolicy from "./red-flags.json" with { type: "json" };
import { RedFlagAnswersSchema } from "./schemas.js";
export const RULE_VERSION = redFlagPolicy.version;
export const RULE_APPROVAL_STATUS = redFlagPolicy.status;
export const RED_FLAG_QUESTIONS = redFlagPolicy.rules.map(({ id, label }) => ({ id: RedFlagAnswersSchema.keyof().parse(id), label }));
const highConcernSymptoms = new Set([
    "BREATHING_DIFFICULTY",
    "CHEST_PAIN",
    "ALTERED_MENTAL_STATUS",
    "SEIZURE",
    "SEVERE_BLEEDING",
]);
const sameDaySymptoms = new Set([
    "DEHYDRATION",
    "ABDOMINAL_PAIN",
    "TRAUMA",
]);
/**
 * Safety decision flow. Keep this diagram synchronized with every branch below.
 *
 * answers → YES? → RED_119
 *         → UNKNOWN? → ASK_MORE
 *         → high-concern symptom or infant fever? → ER_NOW
 *         → same-day symptom? → NIGHT
 *         → otherwise → ASK_MORE
 *
 * These rules are intentionally conservative and remain behind the clinical gate
 * until red-flags.json records an external approval.
 */
export function evaluateTriage(request) {
    const answers = Object.entries(request.redFlags);
    const matchedRedFlags = answers
        .filter(([, answer]) => answer === "YES")
        .map(([id]) => id);
    if (matchedRedFlags.length > 0) {
        return {
            level: "RED_119",
            reasons: ["즉시 확인이 필요한 위험 신호가 선택되었습니다."],
            matchedRedFlags,
        };
    }
    if (answers.some(([, answer]) => answer === "UNKNOWN")) {
        return {
            level: "ASK_MORE",
            reasons: ["위험 신호 여부를 확인해야 다음 안내를 제공할 수 있습니다."],
            matchedRedFlags: [],
        };
    }
    if (request.symptoms.some((symptom) => highConcernSymptoms.has(symptom))) {
        return {
            level: "ER_NOW",
            reasons: ["응급 평가가 필요할 수 있는 증상이 선택되었습니다."],
            matchedRedFlags: [],
        };
    }
    if (request.patient.ageMonths < 3 && request.symptoms.includes("FEVER")) {
        return {
            level: "ER_NOW",
            reasons: ["생후 3개월 미만 영아의 발열이 입력되었습니다."],
            matchedRedFlags: [],
        };
    }
    if (request.symptoms.some((symptom) => sameDaySymptoms.has(symptom))) {
        return {
            level: "NIGHT",
            reasons: ["오늘 안에 의료기관 확인이 필요한 증상이 선택되었습니다."],
            matchedRedFlags: [],
        };
    }
    return {
        level: "ASK_MORE",
        reasons: ["안전한 안내를 위해 증상 정보를 더 확인해야 합니다."],
        matchedRedFlags: [],
    };
}
//# sourceMappingURL=triage.js.map